//@ts-check
/// <reference path="../types.js" />

import { processBranch } from "./processBranch";
import {
  isEdge,
  isTask,
  isTimerEvent,
  isEndNode,
  isBranchNode,
  isConditional,
  processTimerEvent,
  processTask,
} from "./utils";

/**
 * Conta o tempo total do caminho crítico a partir de um nó, acumulando estatísticas.
 * Implementação iterativa usando pilha e funções de identificação de elementos.
 *
 * @param {Elements} elements
 * @param {NodeElement|EdgeElement} startItem
 * @returns {{ branchTime: number, doneTime: number, donePreventTime: number, stats: Array }}
 */
export function count(elements, startItem) {
  let branchTime = 0;
  let doneTime = 0;
  let donePreventTime = 0;
  let stats = [];

  const stack = [{ item: startItem, task: {} }];

  while (stack.length > 0) {
    const stackItem = stack.pop();
    if (!stackItem) continue;

    const { item, task } = stackItem;

    if (!item) continue;

    if (isEdge(item)) {
      const targetNode = elements.find((el) => el.id === item.target);
      if (targetNode) stack.push({ item: targetNode, task });
      continue;
    }

    if (isTask(item) || isTimerEvent(item)) {
      branchTime = isTimerEvent(item)
        ? processTimerEvent(item, stats, branchTime)
        : processTask(item, stats, branchTime);

      const nextEdge = elements.find((e) => e.source === item.id);
      if (nextEdge) stack.push({ item: nextEdge, task });
      continue;
    }

    if (isEndNode(item)) {
      continue;
    }

    if (isBranchNode(item)) {
      const result = processBranch(
        elements,
        item,
        stats,
        branchTime,
        doneTime,
        donePreventTime
      );
      branchTime = result.branchTime;
      doneTime = result.doneTime;
      donePreventTime = result.donePreventTime;

      if (result.next) stack.push({ item: result.next, task: result.task });
      continue;
    }

    // Fallback para condicional simples ou fluxo linear
    const next = elements.find((e) =>
      isConditional(item)
        ? e.source === item.id && e.data.status === "done"
        : e.source === item.id
    );
    if (next) stack.push({ item: next, task });
  }

  return { branchTime, doneTime, donePreventTime, stats };
}
